import { Box, Grid, Card, Stack } from "@mui/material";
import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import { useState, useEffect } from "react";
import useFetch from "../../utils/useFetch";
import axios from "../../utils/fvAxios";
import { useForm } from "react-hook-form";
import BaseURL from "../../utils/base-uri.json";
import GetfVDateFormate from "../../utils/Genaricfunctions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOrgType } from "../../utils/Token";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export default function FinalizeContext({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  FinalizeUserIdAsCompleter,
  FinalizeUserIdAs,
  IsSubSectionCompleted
}) {
  const { t } = useTranslation();

  const params = new URLSearchParams(window.location.search);
  const PQID = params?.get("pqid");

  const [response, setResponse] = useState({});
  const [vendorId, setVendorId] = useState("");
  const [userIdAsCompleter, setUserIdAsCompleter] = useState("");
  const [finalizeVendorUsers, setFinalizeVendorUsers] = useState([]);
  const [vendorUserResponse, setVendorUserResponse] = useState({});
  const [checked, setChecked] = useState(false);
  const [Name, setName] = useState("");

  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    BaseURL.baseUrl +
    "Prequalification/SectionOrSubSectionDetails?pqId=" +
    PQID +
    "&sectionId=" +
    Secid +
    "&subSectionTypeCondition=" +
    SubSectionTypeCondition +
    "&sectionType=" +
    SectionType +
    "&subSectionId=" +
    SubId
  ); // TODO: remove localhost arg

  useEffect(() => {
    if (resp?.data) {
      setResponse(resp?.data);
      setVendorId(resp?.data?.vendorId);
      axios
        .get(
          "Prequalification/FinalizeVendorUsers?vendorId=" +
          resp?.data?.vendorId + "&pqId=" + PQID
        )
        .then((res) => {
          setFinalizeVendorUsers(res?.data?.data);
          //HandleSelect(res?.data?.data[0].text)
          HandleSelect(resp?.data?.userIdAsCompleter?.toUpperCase() == "00000000-0000-0000-0000-000000000000" ? res?.data?.data[0]?.text : resp?.data?.userIdAsCompleter?.toUpperCase());
        });
    }

    // FinalizeVendorUsers();
  }, [resp]);

  // useEffect(() => {
  //   if (finalizeVendorUsers.length > 0) {
  //     setUserIdAsCompleter(finalizeVendorUsers[0].text)
  //   }
  // }, [finalizeVendorUsers]);

  // useEffect(() => {
  //   axios
  //     .get(
  //       "Prequalification/GetVendorUerDetail?userId=" +
  //       userIdAsCompleter
  //     )
  //     .then((res) => {
  //       setVendorUserResponse(res?.data?.data)
  //     });
  // }, [userIdAsCompleter]);



  const HandleSelect = (e) => {
    setUserIdAsCompleter(e);
    axios.get("Prequalification/GetVendorUerDetail?userId=" + e)
      .then((res) => {
        setVendorUserResponse(res?.data?.data)
      });
    FinalizeUserIdAs(e);
  };

  useEffect(() => {
    if (getOrgType() == "Vendor") {
      const data = (finalizeVendorUsers?.find((r) => r?.text == userIdAsCompleter)?.value) == Name ? 1 : 2;
      const VAl = checked == true ? 1 : 2;
      FinalizeUserIdAsCompleter(VAl, data);
    }
  }, [checked, Name]);

  const Date = response?.signedByDateTime
    ? GetfVDateFormate("", response?.signedByDateTime)
    : "";

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  return (
    <>
      <Box sx={{ backgroundColor: "#fff" }}>
        <ToastContainer />
        <p className="mx-3">
          {t("Finalize.MainText")}
          {/* If the information below is incorrect, please go to the {""}
          <strong>My Account</strong> page to make necessary changes or login as
          the user that should submit the data. */}
        </p>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12} sm={12} md={5} alignItems="center">
            <p className="mx-3">{t("Finalize.Selectquestion")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                value={userIdAsCompleter}
                size="small"
                onChange={(e) => HandleSelect(e.target.value)}
                MenuProps={MenuProps}
              >
                {finalizeVendorUsers?.map((item, index) => (
                  <MenuItem key={index} title={item.value} value={item.text}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <hr sx={{ backgroundColor: "#F2F4F7" }} />
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12} sm={12} md={5}>
            <p className="mx-3">{t("Finalize.label1")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <p style={{ color: "#667085" }}>
              {vendorUserResponse?.submittedByContactTitle}
            </p>
          </Grid>
        </Grid>
        <hr />
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12} sm={12} md={5}>
            <p className="mx-3">{t("Finalize.label2")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <p style={{ color: "#667085" }}>
              {vendorUserResponse?.submittedByPhoneNumber}
            </p>
          </Grid>
        </Grid>
        <hr />
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12} sm={12} md={5}>
            <p className="mx-3">{t("Finalize.label3")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={7}>
            <p style={{ color: "#667085" }}>{vendorUserResponse?.submittedByEmail}</p>
          </Grid>
        </Grid>
        <hr />


        <Card
          sx={{
            margin: "auto",
            backgroundColor: "#F2F4F7",
            padding: 2,
            marginTop: 2,
          }}
        >
          <span style={{ color: "#667085", marginRight: "auto" }}>
            {t("Finalize.Section")}
          </span>
        </Card>
        <p className="mx-3" style={{ marginTop: "10px" }}>
          {t("Finalize.MainText2")}
        </p>
        <div hidden={getOrgType() == "Vendor" && !IsSubSectionCompleted}> 
        {/* !response?.signedByUserName */}
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={5}>
              <p className="mx-3">{t("Finalize.label4")}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={7}>
              <p style={{ color: "#667085" }}></p>
              {response?.signedByUserName}
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={5}>
              <p className="mx-3">{t("Finalize.label3")}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={7}>
              <p style={{ color: "#667085" }}></p>
              {response?.signedByUserEmail}
            </Grid>
          </Grid>
          <hr />
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            <Grid item xs={12} sm={12} md={5}>
              <p className="mx-3">{t("Finalize.label5")}</p>
            </Grid>
            <Grid item xs={12} sm={12} md={7}>
              <p style={{ color: "#667085" }}></p>
              {Date}
            </Grid>
          </Grid>
        </div>

        
        <div hidden={getOrgType() !== "Vendor"}>
          <div hidden={IsSubSectionCompleted}>
            <span className="mx-3">
              Check the box below to confirm:
            </span>

            <Stack direction={"row"} sx={{ marginTop: "10px", marginBottom: "20px" }}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      className="mx-4"
                      checked={checked}
                      onChange={(e) => setChecked(e?.target?.checked)}
                      size="medium"

                    />
                  }
                />
              </FormGroup>
              <span style={{ fontWeight: "bold" }}>
                I certify that the information provided herein is complete and accurate.
              </span>
            </Stack>
          </div>

          <hr />
          <div className="mx-3" hidden={IsSubSectionCompleted}>
            <span >
              Type your full name exactly as it appears in the section above (case-sensitive):
            </span>
            <br />
            <TextField
              sx={{ marginBottom: "20px" }}
              size="small"
              value={Name}
              onChange={(e) => setName(e?.target?.value)}
            />
          </div>
        </div>
      </Box>
    </>
  );
}
